module.exports = __webpack_public_path__ + "img/height_armhole.f942765d.png";